// extracted by mini-css-extract-plugin
export var bottom = "showcases-module--bottom--ade93";
export var contributions = "showcases-module--contributions--da63a";
export var heading = "showcases-module--heading--4193f";
export var horizontalSpacer = "showcases-module--horizontalSpacer--cf92f";
export var horizontalSpacerLast = "showcases-module--horizontalSpacerLast--337a1";
export var image = "showcases-module--image--afe52";
export var info = "showcases-module--info--9bfb8";
export var left = "showcases-module--left--b2a2d";
export var picture = "showcases-module--picture--71b0d";
export var play = "showcases-module--play--f9c4f";
export var recentChallenge = "showcases-module--recentChallenge--91832";
export var right = "showcases-module--right--8bb34";
export var verticalSpacer = "showcases-module--verticalSpacer--55de0";